import { isDesktop } from '@/const/version';

export const BUSINESS_LINE = isDesktop ? 'silvertiger-chat-desktop' : 'silvertiger-chat';
